/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as creator_contact from "../data/creator_contact";
export { api, creator_contact };
import { method, headers, queryStringify } from "../../_util";
export var ContactScene = {
  Default: 1,
  Affiliate_Profile: 10,
  Affiliate_IM: 11,
  Affiliate_Invite: 12,
  Partner_Rec: 20,
  Partner_Profile: 21
};
export var CreatorContactApiSens = /*#__PURE__*/function () {
  function CreatorContactApiSens(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = CreatorContactApiSens.prototype;
  _proto.GetCreatorContactInfo = function GetCreatorContactInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/cmp/contact" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorContactTypes = function GetCreatorContactTypes(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api_sens/v" + (request.version || "1") + "/affiliate/cmp/contact_types" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  return CreatorContactApiSens;
}();
export var creatorContactApiSensClient = new CreatorContactApiSens();